import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import "../style/homepageuser.css";
import WhiteLogo from "../assets/images/whitelogo.png";
import LogoWithText from "../assets/images/logowithtext.png";
import Hompage1 from "../assets/images/homepage1.png";
import Hompage2 from "../assets/images/hompage2.jpeg";

const videoSection3 =
  "https://www.dropbox.com/scl/fi/zqk8674ogmuzov9fnt05s/CEA-Founders-Talk-Full.mp4?rlkey=rru50i2n1ts2j5x41v48ng6yr&raw=1";

const bannerDestination = {
  early_registration: "/earlyregistration",
  masterclass: "/registermasterclass",
  conference: "/registerconference",
  openclass: "/registeropenclass",
  orientation: "/registerorientation",
  graduation: "/registergraduation",
};

const Homepage = ({ setLocation, classDetails }) => {
  const navigate = useNavigate();
  const address = useLocation();
  const [banners, setBanners] = useState([]);
  const [bannerVisible, setBannerVisible] = useState(false);
  const [bannerLoading, setBannerLoading] = useState(true);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isMobilePortrait, setIsMobilePortrait] = useState(
    window.innerWidth <= 767.99 && window.innerHeight > window.innerWidth,
  );

  // Dipakai buat pilih foto portrait (kalau ada) vs landscape untuk banner —
  // background-image inline style tidak bisa pakai @media, jadi dipilih di JS
  // (mirrors isMobile pattern di App.js), supaya foreground & blurred
  // background selalu pakai foto yang SAMA, tidak campur landscape+portrait.
  useEffect(() => {
    const handleResize = () => {
      setIsMobilePortrait(window.innerWidth <= 767.99 && window.innerHeight > window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const bannerImageFor = (banner) =>
    isMobilePortrait && banner.imagePortraitUrl ? banner.imagePortraitUrl : banner.imageUrl;

  const handleNavigate = (goto) => {
    navigate(goto);
  };

  useEffect(() => {
    setLocation(address);
  }, []);

  useEffect(() => {
    Promise.all([
      axios.get("/banner/visibility").catch(() => ({ data: { visible: false } })),
      axios.get("/banners").catch(() => ({ data: [] })),
    ]).then(([visRes, bannersRes]) => {
      setBannerVisible(visRes.data.visible);
      setBanners(bannersRes.data);
    }).finally(() => setBannerLoading(false));
  }, []);

  useEffect(() => {
    if (banners.length <= 1) return;
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % banners.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [banners]);

  if (bannerLoading) {
    return (
      <div style={{
        position: "fixed", inset: 0, backgroundColor: "#fff",
        display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center",
        zIndex: 9999, gap: "32px",
      }}>
        <img
          src={LogoWithText}
          alt="Cutting Edge Academy"
          style={{ width: "min(260px, 60vw)", objectFit: "contain", animation: "fadeInUp 0.6s ease forwards" }}
        />
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "14px" }}>
          <div style={{
            width: "44px", height: "44px",
            border: "4px solid #f0f0f0",
            borderTop: "4px solid #fb3104",
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
          }} />
          <p style={{ margin: 0, fontSize: "13px", color: "#aaa", letterSpacing: "1.5px", textTransform: "uppercase", fontWeight: "500" }}>
            Loading...
          </p>
        </div>
      </div>
    );
  }

  return (
    <main>
      {/* BANNER SLIDER */}
      {bannerVisible && banners.length > 0 ? (
        <div style={{ position: "relative", width: "100%", overflow: "hidden", backgroundColor: "#000" }}>
          {/* SLIDES */}
          <div style={{ position: "relative", width: "100%", height: "90vh" }}>
            {banners.map((banner, index) => (
              <div
                key={banner.id}
                style={{
                  position: "absolute",
                  inset: 0,
                  opacity: index === activeIndex ? 1 : 0,
                  transition: "opacity 0.7s ease",
                  pointerEvents: index === activeIndex ? "auto" : "none",
                  overflow: "hidden",
                }}
              >
                {/* Blurred background — fills empty space around contained image */}
                <div
                  style={{
                    position: "absolute",
                    inset: "-30px",
                    backgroundImage: `url(${bannerImageFor(banner)})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    filter: "blur(24px) brightness(0.55)",
                    zIndex: 0,
                  }}
                />
                {/* Main image — fully visible, not cropped */}
                <img
                  src={bannerImageFor(banner)}
                  alt={banner.title}
                  style={{
                    position: "absolute",
                    inset: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    display: "block",
                    zIndex: 1,
                  }}
                />
                {/* Text & button overlay */}
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    zIndex: 2,
                    background: "linear-gradient(to top, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0.05) 50%, transparent 100%)",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    padding: "32px 24px",
                    textAlign: "center",
                  }}
                >
                  <h2 style={{ color: "#fff", fontWeight: "800", fontSize: "clamp(18px, 3.5vw, 40px)", margin: "0 0 8px", textShadow: "0 2px 8px rgba(0,0,0,0.5)" }}>
                    {banner.title}
                  </h2>
                  {banner.subtitle && (
                    <p style={{ color: "rgba(255,255,255,0.88)", fontSize: "clamp(13px, 2vw, 18px)", margin: "0 0 20px", textShadow: "0 1px 4px rgba(0,0,0,0.5)" }}>
                      {banner.subtitle}
                    </p>
                  )}
                  <button
                    onClick={() => handleNavigate(bannerDestination[banner.type] || "/programs")}
                    style={{
                      backgroundColor: "#fb3104",
                      color: "#fff",
                      border: "none",
                      borderRadius: "30px",
                      padding: "10px 32px",
                      fontWeight: "700",
                      fontSize: "clamp(13px, 1.8vw, 16px)",
                      cursor: "pointer",
                      letterSpacing: "0.5px",
                      boxShadow: "0 4px 12px rgba(251,49,4,0.4)",
                    }}
                  >
                    Register Now
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* PREV / NEXT — hanya jika lebih dari 1 banner */}
          {banners.length > 1 && (
            <>
              <button
                onClick={() => setActiveIndex((prev) => (prev - 1 + banners.length) % banners.length)}
                style={{
                  position: "absolute", top: "50%", left: "16px", transform: "translateY(-50%)",
                  backgroundColor: "rgba(0,0,0,0.4)", color: "#fff", border: "none",
                  borderRadius: "50%", width: "40px", height: "40px", fontSize: "18px",
                  cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
                  zIndex: 10,
                }}
              >
                ‹
              </button>
              <button
                onClick={() => setActiveIndex((prev) => (prev + 1) % banners.length)}
                style={{
                  position: "absolute", top: "50%", right: "16px", transform: "translateY(-50%)",
                  backgroundColor: "rgba(0,0,0,0.4)", color: "#fff", border: "none",
                  borderRadius: "50%", width: "40px", height: "40px", fontSize: "18px",
                  cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
                  zIndex: 10,
                }}
              >
                ›
              </button>

              {/* DOT INDICATORS */}
              <div style={{ position: "absolute", bottom: "14px", left: "50%", transform: "translateX(-50%)", display: "flex", gap: "8px", zIndex: 10 }}>
                {banners.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setActiveIndex(i)}
                    style={{
                      width: i === activeIndex ? "24px" : "8px",
                      height: "8px",
                      borderRadius: "4px",
                      border: "none",
                      backgroundColor: i === activeIndex ? "#fb3104" : "rgba(255,255,255,0.6)",
                      cursor: "pointer",
                      padding: 0,
                      transition: "width 0.3s ease, background-color 0.3s ease",
                    }}
                  />
                ))}
              </div>
            </>
          )}
        </div>
      ) : null}

      <div className="custom-con-section1-hmpg position-relative">
        <div className="custom-con-img-section1-hmpg">
          <img
            className="adjust-img1-section1-hmpg object-fit-cover"
            src={Hompage1}
            alt="TeacherImage.png"
          />
        </div>
        <div className="custom-con2-img2-section1-hmpg position-absolute top-50 start-50">
          <img
            className="adjust-img1-section1-hmpg object-fit-cover"
            src={Hompage2}
            alt="TeacherImage.png"
          />
        </div>
        <div className="custom-con-content-section1-hmpg position-absolute top-50 start-50 translate-middle d-flex justify-content-center align-items-center flex-column">
          <div className="custom-con-img2-section1-hmpg">
            <img
              className="adjust-img2-hmpg object-fit-scale"
              src={WhiteLogo}
              alt="whitelogo.png"
            />
          </div>
          <p className="custom-text1-section1-hmpg">Championing</p>
          <p className="custom-text2-section1-hmpg">Leaders</p>
          <button
            className="custom-btn-section1-hmpg"
            onClick={() => handleNavigate("/courses")}
          >
            EXPLORE COURSE
          </button>
        </div>
      </div>
      <div className="custom-con-content-section2-hmpg d-flex justify-content-center align-items-center">
        <div className="custom-width-content-section2-hmpg d-flex justify-content-center align-items-center flex-column">
          <p className="custom-text-section2-hmpg text-center">
            "For we are God's masterpiece.
            <br /> He has created us anew in Christ Jesus, so we do the good
            things he planned for us long ago." Eph 2:10 NLT
          </p>
          <button
            className="custom-btn-section2-hmpg"
            onClick={() => handleNavigate("/programs")}
          >
            Register Now
          </button>
        </div>
      </div>
      <div className="custom-con-content-section3-hmpg d-flex align-items-center justify-content-center">
        <div className="row align-items-center custom-row-section3-hmpg">
          <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xs-6 col-xxl-6 p-0 d-flex align-items-center justify-content-center">
            <div className="custom-con-vid-section3-hmpg">
              <video
                width="100%"
                height="100%"
                className="object-fit-cover"
                controls
                controlsList="nodownload"
                disablePictureInPicture
                onContextMenu={(e) => e.preventDefault()}
                preload="metadata"
                loop
              >
                <source src={videoSection3} type="video/mp4" />
              </video>
            </div>
          </div>
          <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xs-6 col-xxl-6 p-0 d-flex align-items-center justify-content-center flex-column">
            <p className="custom-text-section3-hmpg text-center">
              Cutting Edge Academy is a learning program with a purpose to
              develop Christians and leaders to become increasingly rooted in
              God's word and able to serve relevantly and strategically.
            </p>

            <button
              className="custom-btn-section3-hmpg"
              onClick={() => handleNavigate("/about")}
            >
              About Us
            </button>
          </div>
        </div>
      </div>
      <div className="custom-con-content-section4-hmpg d-flex align-items-center justify-content-center">
        <div className="custom-con-width-section4-hmpg">
          <p className="custom-title-section4-hmpg text-center">Our Subjects</p>
          <div className="row align-items-center justify-content-center custom-row-section4-hmpg">
            {classDetails.map((item, index) => (
              <div
                className="col-12 col-md-4 col-lg-4 col-xl-4l col-xxl-4 d-flex align-items-center justify-content-center p-0"
                key={index}
              >
                <div className="custom-con-content-column-section4-hmpg d-flex justify-content-center flex-column p-4">
                  <p className="custom-title-card-section4-hmpg">
                    {item.className}
                  </p>
                  <p className="custom-text-card-section4-hmpg">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
};

export default Homepage;
